/**
 * How many chips fit in `available` pixels, given each chip's width, the gap
 * between chips and the width of the "+N" chip that replaces the rest.
 * Always shows at least one chip (it is cut short with "…" if needed).
 */
export const countFittingChips = (
  chipWidths: number[],
  available: number,
  gap: number,
  moreWidth: (hidden: number) => number,
) => {
  const total = chipWidths.length;
  if (total === 0) return 0;

  const widthOf = (count: number) =>
    chipWidths.slice(0, count).reduce((sum, width) => sum + width, 0) +
    gap * Math.max(0, count - 1);

  if (widthOf(total) <= available) return total;

  for (let count = total - 1; count >= 1; count -= 1) {
    if (widthOf(count) + gap + moreWidth(total - count) <= available) {
      return count;
    }
  }

  return 1;
};
